import {
  apiDeleteClinicalStudiesAssociationSymptomsSymptomUuidVisitUuid,
  apiPostClinicalStudiesAssociationSymptoms,
  apiPostSymptoms,
  VisitAvailableSymptoms,
} from "../../../api";
import { useSupportedSymptoms } from "../../../catalogs/supported-symptoms";
import { getServerNowISO } from "../../../utils/server-time";
import { useSoftAssert } from "../../../utils/use-soft-assert";
import { Patient } from "../patient";
import { SymptomsTable } from "../symptoms/symptoms-table";
import { BaseDataVisitField, Submittable } from "./base-data-visit-field";

export function SymptomDataVisitField(props: {
  prefill: VisitAvailableSymptoms;
  patient: Patient;
  ref: (h: Submittable) => void;
  visitUuid: string;
}) {
  const supportedSymptoms = useSupportedSymptoms();
  const variableInfo = supportedSymptoms.find(
    (d) => d.data_name === props.prefill.data_definition.data_name,
  );

  if (!useSoftAssert(variableInfo, "Symptom definition not found")) {
    return null;
  }

  return (
    <BaseDataVisitField
      associatedData={props.prefill.associated_data}
      existingData={props.prefill.existing_data}
      patient={props.patient}
      valueSelector={(d) => d.symptom_value}
      variableInfo={variableInfo}
      ref={props.ref}
      existingDataTable={(p) => (
        <SymptomsTable
          api={props.patient.api}
          patient={props.patient}
          disableEdit
          disableHistory
          disablePagination
          canSelect="multi"
          {...p}
        />
      )}
      onSubmit={async ({ newValue, editedValue, addedUuids, removedUuids }) => {
        if (editedValue) {
          await props.patient.updateItem("symptoms", editedValue.uuid, {
            symptom_value: editedValue.value,
          });
        }

        if (newValue != null) {
          await apiPostSymptoms({
            body: {
              patient_id: props.patient.patientId,
              symptom_value: newValue as any,
              symptom_name: props.prefill.data_definition.data_name,
              symptom_change_in_last_six_m: false, // TODO?
              symptom_datetime: getServerNowISO(),
              study_visit_link: props.visitUuid,
            },
          });
        }

        if (addedUuids && addedUuids.length > 0) {
          await apiPostClinicalStudiesAssociationSymptoms({
            body: {
              number_of_datapoints: addedUuids.length,
              associations: addedUuids.map((uuid) => ({
                symptom_uuid: uuid,
                study_visit_uuid: props.visitUuid,
              })),
            },
          });
        }

        for (const uuid of removedUuids ?? []) {
          await apiDeleteClinicalStudiesAssociationSymptomsSymptomUuidVisitUuid(
            { path: { symptom_uuid: uuid, visit_uuid: props.visitUuid } },
          );
        }
      }}
    />
  );
}
